module.exports = __webpack_public_path__ + "img/item-separator.954f4fc4.svg";